import { render, staticRenderFns } from "./vimeodesktop.vue?vue&type=template&id=fd50942e&"
import script from "./vimeodesktop.vue?vue&type=script&lang=js&"
export * from "./vimeodesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports